/**
 * React Query hook for fetching projects
 * Story 226: Projects Dashboard
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

/** Project list item from API */
export interface ProjectListItem {
  id: string;
  slug: string;
  name: string;
  github_repo_id: number | null;
  has_access: boolean;
  stats: {
    story_count: number;
    in_progress_count: number;
    done_count: number;
    user_count: number;
  };
  recent_users: Array<{ github_username: string | null }>;
  updated_at: string;
}

/** Response from GET /api/v1/projects */
export interface ProjectListResponse {
  accessible: ProjectListItem[];
  inaccessible: ProjectListItem[];
}

/** Query key factory for projects */
export const projectKeys = {
  all: ['projects'] as const,
  list: () => [...projectKeys.all, 'list'] as const,
};

/** Fetch projects for the current user */
async function fetchProjects(): Promise<ProjectListResponse> {
  return api.fetch('/api/v1/projects');
}

/**
 * Hook to fetch user's projects with access status
 */
export function useProjects() {
  return useQuery({
    queryKey: projectKeys.list(),
    queryFn: fetchProjects,
  });
}
